<template>
    <div class="navigator">
        <!-- <h2 class="mr-auto">{{ selectedPerson ? selectedPerson.name : 'New Agent' }}</h2> -->
        <h2 class="mr-auto">{{ navigatorTitle }}</h2>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        props: {
            selectedPerson: {
                type: Object,
                required: false,
            },
            passedForm: {
                type: Object,
                required: false,
            },
        },
        computed: {
            ...mapGetters([
                'getIsGettingAgentInfo'
            ]),
            navigatorTitle: function () {
                if(this.selectedPerson){
                    return this.selectedPerson.name
                } else if(this.getIsGettingAgentInfo){
                    return 'Loading...'
                } else if(this.passedForm.name){
                    return this.passedForm.name
                } else {
                    return 'New Agent'
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// AgentNavigator.vue?6554b2b9